<template>
  <form class="p-mypage_registration__form" @submit.prevent="handleSubmit">
    <div class="p-mypage_registration__title">
      <p class="f_18 bold">登録情報の確認・変更</p>
      <p class="edit" v-if="!isEdit"><a href="javascript:void(0);" @click="edit()">編集する<img src="/images/pc/edit.png" alt=""></a></p>
    </div>

    <table class="p-mypage_registration__form__table p-pb-10 pb-10">
      <tr>
        <th>お名前</th>
        <td><p>{{ info.name }}</p></td>
      </tr>
      <tr>
        <th>よみがな</th>
        <td><p>{{ info.name_kana }}</p></td>
      </tr>
      <tr>
        <th>メールアドレス</th>
        <td><p>{{ info.email }}</p></td>
      </tr>
      <tr>
        <th>携帯番号</th>
        <td><p>{{ info.tel }}</p></td>
      </tr>
      <tr>
        <th>生年月日</th>
        <td>
          <p v-if="!isEdit">{{ info.dob }}</p>
          <text-input-only v-if="isEdit" type="text" :only-number="true" :maxlength="4" class="w53" v-model="form.params.dob_year" placeholder="2000"/><span v-if="isEdit" class="date">年</span>
          <text-input-only v-if="isEdit" type="text" :only-number="true" :maxlength="2" class="w33" v-model="form.params.dob_month" placeholder="01" /><span v-if="isEdit" class="date">月</span>
          <text-input-only v-if="isEdit" type="text" :only-number="true" :maxlength="2" class="w33" v-model="form.params.dob_day" placeholder="01" /><span v-if="isEdit" class="date">日</span>
          <error-message v-if="form.errors.first('dob_year')" :message="form.errors.first('dob_year')"></error-message>
          <error-message v-if="form.errors.first('dob_month')" :message="form.errors.first('dob_month')"></error-message>
          <error-message v-if="form.errors.first('dob_day')" :message="form.errors.first('dob_day')"></error-message>
          <error-message v-if="form.errors.first('dob') && !form.errors.first('dob_year') && !form.errors.first('dob_month') && !form.errors.first('dob_day')" :message="form.errors.first('dob')"></error-message>
        </td>
      </tr>
      <tr>
        <th>性別</th>
        <td>
          <p v-if="!isEdit">{{ getGender(info.gender_id) }}</p>
          <radio-box-group v-if="isEdit" :options="gender" v-model="form.params.gender_id" />
          <error-message v-if="form.errors.first('gender_id')" :message="form.errors.first('gender_id')"></error-message>
        </td>
      </tr>
      <tr>
        <th>住所</th>
        <td>
          <span v-if="isEdit || info.zipcode" class="postcode">〒</span>
          <span v-if="!isEdit">{{ info.zipcode }}</span>
          <text-input-only type="text" v-if="isEdit" :only-number="true" class="w68" v-model="form.params.zipcode" placeholder="ハイフン無し"/><br>
          <error-message v-if="form.errors.first('zipcode')" :message="form.errors.first('zipcode')"></error-message>

          <p v-if="!isEdit">{{ info.address }}</p>
          <text-input-only v-if="isEdit" class="w100 mt15" v-model="form.params.address" placeholder="都道府県　市区町村　番地"/>
          <error-message v-if="form.errors.first('address')" :message="form.errors.first('address')"></error-message>
          
          <p v-if="!isEdit">{{ info.building_name }}</p>
          <text-input-only v-if="isEdit" class="w100 mt11" v-model="form.params.building_name" placeholder="ビル名・マンション名"/>
          <error-message v-if="form.errors.first('building_name')" :message="form.errors.first('building_name')"></error-message>
        </td>
      </tr>
      <tr>
        <th>最寄駅</th>
        <td>
          <p v-if="!isEdit">{{ info.station }}</p>
          <text-input-only v-if="isEdit" class="w100" v-model="form.params.station" placeholder="JR山手線　神田駅"/>
          <error-message v-if="form.errors.first('station')" :message="form.errors.first('station')"></error-message>
        </td>
      </tr>
      <tr>
        <th>通勤希望時間</th>
        <td>
          <p v-if="!isEdit">{{ info.commuting_time }}</p>
          <text-input-only v-if="isEdit" class="w100" v-model="form.params.commuting_time" placeholder="1時間ほど"/>
          <error-message v-if="form.errors.first('commuting_time')" :message="form.errors.first('commuting_time')"></error-message>
        </td>
      </tr>
      <tr>
        <th>希望単価</th>
        <td>
          <span v-if="!isEdit && info.price">{{ info.price }}</span>
          <text-input-only v-if="isEdit" class="w56" v-model="form.params.price" placeholder="55〜60"/><span class="unit" v-if="isEdit || (!isEdit && info.price)">万円／月額</span>
          <error-message v-if="form.errors.first('price')" :message="form.errors.first('price')"></error-message>
        </td>
      </tr>
      <tr>
        <th>希望案件</th>
        <td>
          <p class="pre-formatted" v-if="!isEdit">{{ info.request_job }}</p>
          <textarea-input v-if="isEdit" v-model="form.params.request_job" placeholder="例）言語はPHPでサーバサイドの開発が得意です。基本設計〜テストまで対応可能です。フレームワークはLaravelだと尚嬉しい。"/>
          <error-message v-if="form.errors.first('request_job')" :message="form.errors.first('request_job')"></error-message>
        </td>
      </tr>
      <tr>
        <th>その他条件</th>
        <td>
          <p class="pre-formatted" v-if="!isEdit">{{ info.other_request }}</p>
          <textarea-input v-if="isEdit" v-model="form.params.other_request" placeholder="例）勤務時間9:00〜18:00の案件が希望です。"/>
          <error-message v-if="form.errors.first('other_request')" :message="form.errors.first('other_request')"></error-message>
        </td>
      </tr>
    </table>
    <div v-if="isEdit" class="p-mypage_registration__form__submit">
      <input type="submit" value="登録更新" :disabled="sending">
    </div>
  </form>
</template>

<script>
import Form from "@/utils/Form";
import TextInputOnly from '@/shared/Input/TextInputOnly'
import RadioBoxGroup from '@/shared/Input/RadioBoxGroup'
import TextareaInput from '@/shared/Input/TextareaInput'
import ErrorMessage from '@/shared/Input/ErrorMessage'
import { Gender } from "@/plugins/global-constant"
import { formatPrice, formatDate } from '@/utils/Helper'

export default {
  props: {
    user: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    TextInputOnly,
    RadioBoxGroup,
    TextareaInput,
    ErrorMessage
  },
  data() {
    return {
      info: this.user,
      form: [],
      sending: false,
      isSuccess: false,
      isEdit: false,
      gender: Gender.getList()
    }
  },
  methods: {
    setForm () {
      const dobs = this.info &&  this.info.dob ? this.info.dob.split('-') : null;
      this.form = new Form({
        dob_year: dobs ? dobs[0] : null,
        dob_month: dobs ? dobs[1] : null,
        dob_day: dobs ? dobs[2] : null,
        gender_id: this.info ? this.info.gender_id : null,
        zipcode: this.info ? this.info.zipcode : null,
        address: this.info ? this.info.address : null,
        building_name: this.info ? this.info.building_name : null,
        station: this.info ? this.info.station : null,
        commuting_time: this.info ? this.info.commuting_time : null,
        price: this.info ? this.info.price : null,
        request_job: this.info ? this.info.request_job : null,
        other_request: this.info ? this.info.other_request : null,
      })
    },

    handleSubmit () {
      if (this.sending) {
        return;
      }
      this.sending = true;
      this.isSuccess = false;
      this.form
          .put({
            url: "/mypage/info/" + this.info.id,
          })
          .then(({data: {data}}) => {
            this.isSuccess = true;
            flash('更新しました。', 'success');
            window.scrollTo(0, 0);
            this.sending = false;
            this.isEdit = false;
            this.info = data;
            this.setForm();
          })
          .catch((error) => {
            this.sending = false;
            window.scrollTo(0, 0);
          });
    },

    edit() {
      this.isSuccess = false;
      this.isEdit = true;
    },
    getGender(gender) {
      return Gender.getName(gender)
    },

    formatPrice(price) {
      return price ? formatPrice(price) : null;
    },

    formatDate(date) {
      return formatDate(date, 'YYYY.MM.DD')
    },
  },
  mounted() {
  },
  computed: {
  },
  created() {
    this.setForm()
  },
}
</script>
